import { useEffect, useRef } from 'react'
import { Props_SnippetPvp } from './Pvp.props'
import { Legacy_CompileMarkdown } from '@ClientBase/React/ReactSnippetMDCompiler'
import { createPvpCarousel } from '../Carousels'

const SnippetPvp = (props: Props_SnippetPvp) => {
    const carouselRef = useRef<HTMLDivElement>(null)
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-pvp__heading--${heading.visibility.value}` : ''

    useEffect(() => {
        createPvpCarousel(carouselRef)
    }, [])

    return (
    <section className="snippet-pvp">
        <div className="snippet-pvp__container">
            <h2 className={`snippet-pvp__heading ${classHeadingVisibility}`}>{ heading.content.value }</h2>
            <div className="snippet-pvp__container-entries" ref={carouselRef}>
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className="snippet-pvp__entry">
                    <figure className="snippet-pvp__entry-image-container">
                        <img
                            className="snippet-pvp__entry-image"
                            loading="lazy"
                            height={540}
                            width={710}
                            src={entry.image?.value}
                            alt={entry.alt?.value ? entry.alt.value : ''}
                        />
                    </figure>
                    <div className="snippet-pvp__entry-content-container">
                        <div className="snippet-pvp__entry-heading-container">
                            { entry.icon?.value && (
                                <img
                                    className="snippet-pvp__entry-icon"
                                    loading="lazy"
                                    height={70}
                                    width={70}
                                    src={entry.icon?.value}
                                    alt=""
                                />
                            )}
                            { entry.heading?.value && <h3 className="snippet-pvp__entry-heading">{ entry.heading.value }</h3> }
                        </div>
                        { entry.content?.value && <div className="snippet-pvp__entry-content">{ Legacy_CompileMarkdown(entry.content.value) }</div> }
                        { entry.linkContent?.value && entry.linkUrl?.value && entry.linkTarget?.value && (
                            <a
                                href={entry.linkUrl.value}
                                className="snippet-pvp__entry-link"
                                target={entry.linkTarget.value === 'true' ? '_blank' : '_self'}
                                rel={entry.linkTarget.value === 'true' ? 'noopener noreferrer' : ''}
                            >
                                { entry.linkContent.value }
                            </a>
                        )}
                    </div>
                </div>
            ))}
            </div>
        </div>
    </section>
    )
}

export default SnippetPvp